import React, { useState } from "react";
import { loginSuccess } from "../redux/auth/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const [toaster, setToaster] = useState({ show: false, type: "", text: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    setToaster({ show: false });

    try {
      const response = await fetch(`${BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        dispatch(loginSuccess(data.user, data.token));
        sessionStorage.setItem("token", data.token);

        setToaster({ show: true, type: "success", text: "Login successful!" });
        setTimeout(() => navigate("/"), 1200);
      } else {
        setToaster({ show: true, type: "error", text: data.message });
      }
    } catch (error) {
      setToaster({
        show: true,
        type: "error",
        text: "Unable to connect to the server.",
      });
    } finally {
      setLoader(false);
    }
  };

  const S = {
    outer: {
      minHeight: "100vh",
      width: "100vw",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#f5f7fa",
      fontFamily:
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial",
      padding: "20px",
    },
    container: {
      display: "flex",
      width: "100%",
      maxWidth: "900px",
      background: "#ffffff",
      borderRadius: "18px",
      boxShadow: "0 10px 35px rgba(0,0,0,0.08)",
      overflow: "hidden",
    },
    left: {
      flex: 1,
      background: "#f0f3f7",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
    },
    right: {
      flex: 1,
      padding: "48px 40px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    img: {
      width: "85%",
      maxWidth: "380px",
      borderRadius: "16px",
    },
    title: {
      fontSize: "30px",
      fontWeight: "600",
      color: "#1f2430",
      marginBottom: "6px",
      textAlign: "center", // changed from center to left
      lineHeight: "1.2", // ensures single line if possible
      whiteSpace: "nowrap", // keeps it in one line
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    subtitle: {
      fontSize: "15px",
      color: "#6b7280",
      marginBottom: "28px",
      textAlign: "center", // changed from center to left
    },
    inputGroup: { marginBottom: "20px" },
    label: {
      fontSize: "14px",
      color: "#374151",
      fontWeight: "500",
      marginBottom: "6px",
      display: "block",
    },
    input: {
      width: "100%",
      padding: "12px 14px",
      borderRadius: "8px",
      fontSize: "15px",
      border: "1px solid #d1d5db",
      outline: "none",
      transition: ".2s",
    },
    button: {
      width: "100%",
      padding: "14px",
      borderRadius: "8px",
      background: "#2563eb",
      color: "#fff",
      border: "none",
      fontSize: "15px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "background .2s",
      marginTop: "10px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    spinner: {
      width: "16px",
      height: "16px",
      borderRadius: "50%",
      border: "2px solid rgba(255,255,255,0.4)",
      borderTopColor: "#fff",
      marginRight: "10px",
      animation: "spin .6s linear infinite",
    },
    toast: {
      position: "fixed",
      bottom: "24px",
      left: "50%",
      transform: "translateX(-50%)",
      padding: "12px 22px",
      borderRadius: "6px",
      color: "#fff",
      fontSize: "14px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      animation: "fade .3s ease",
    },
  };

  return (
    <>
      <div style={S.outer}>
        <div style={S.container}>
          {/* LEFT IMAGE */}
          <div style={S.left}>
            <img src="/Login.png" alt="Login Illustration" style={S.img} />
          </div>

          {/* RIGHT */}
          <div style={S.right}>
            <h1 style={S.title}>Stellarmind.ai Admin Login</h1>
            <p style={S.subtitle}>
              Manage your platform, data, and internal operations with ease.
            </p>
            <form onSubmit={handleSubmit}>
              <div style={S.inputGroup}>
                <label style={S.label}>Email</label>
                <input
                  type="email"
                  placeholder="Enter your email"
                  required
                  style=    {S.input}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div style={S.inputGroup}>
                <label style={S.label}>Password</label>
                <div style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your password"
                    required
                    style={{ ...S.input, paddingRight: "70px" }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />

                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "none",
                      border: "none",
                      color: "#2563eb",
                      fontSize: "13px",
                      cursor: "pointer",
                    }}
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                disabled={loader}
                style={{ ...S.button, opacity: loader ? 0.6 : 1 }}
              >
                {loader && <span style={S.spinner}></span>}
                {loader ? "Signing in..." : "Continue"}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* ANIMATIONS */}
      <style>{`
        @keyframes spin { 
          0% {transform: rotate(0deg);} 
          100% {transform: rotate(360deg);} 
        }
        @keyframes fade {
          from {opacity: 0; transform: translateY(10px);}
          to {opacity: 1; transform: translateY(0);}
        }
        @media (max-width: 850px) {
          div[style*="max-width: 900px"] {
            flex-direction: column;
            border-radius: 12px;
          }
          div[style*="background: #f0f3f7"] {
            height: 180px;
          }
        }
      `}</style>

      {/* TOAST */}
      {toaster.show && (
        <div
          style={{
            ...S.toast,
            backgroundColor:
              toaster.type === "success" ? "#16a34a" : "#dc2626",
          }}
        >
          {toaster.text}
        </div>
      )}
    </>
  );
}

export default Login;
